import React, { Component } from "react";
import { Select } from "antd";
import { AntSelect } from "./styles/select.style";
import WithDirection from "../misc/theme/withDirection";

const WDSelect = AntSelect(Select);
const isoSelect = WithDirection(WDSelect);
const SelectOption = Select.Option;

export default disabledTextSelect(isoSelect);
export { SelectOption };

function disabledTextSelect(WrappedSelect) {
  return class Select extends Component {
    disableInput() {
      const selects = document.getElementsByClassName(
        `ant-select-search__field`
      );
      for (let el of selects) {
        el.setAttribute(`maxlength`, 0);
      }
    }
    componentDidMount() {
      this.disableInput();
    }
    render() {
      return <WrappedSelect {...this.props} />;
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/ui-ant/elements/select.js